module.exports = __webpack_public_path__ + "static/media/other-benefit.dd3953e6.svg";